import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateRetailer } from '../actions/Retailer';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import API from '../api';

import Loader from './Loader';
import notify from './Notification/helper';
import { chooseInputComponent } from '../common/utils/components';
import PropTypes from 'prop-types';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function BrandMediaForm() {
  const retailer = useSelector(state => state.retailer);
  const dispatch = useDispatch();

  const [retailerPayload, setRetailerPayload] = useState({
    logo: retailer.logo,
    placeholder_image: retailer.placeholder_image,
    poster_partner_name: retailer.poster_partner_name ?? '',
    poster_partner_logo: retailer.poster_partner_logo ?? '',
  });

  useEffect(() => {
    setRetailerPayload((prev) => ({
      ...prev,
      poster_partner_name: retailer.poster_partner_name ?? '',
      poster_partner_logo: retailer.poster_partner_logo ?? '',
    }));
  }, [retailer?.poster_partner_name, retailer?.poster_partner_logo]);

  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    let keyValuePair = {};
    keyValuePair[field] = value;

    setRetailerPayload({
      ...retailerPayload,
      ...keyValuePair
    })
  };

  const formSections = [
    {
      title: 'Media Settings',
      fields: [
        {
          name: 'logo',
          label: 'Logo',
          description: '',
          type: 'image',
          value: retailerPayload.logo,
          handleInputChange: handleInputChange,
        },
        {
          name: 'placeholder_image',
          label: 'Default Placeholder',
          description: '',
          type: 'image',
          value: retailerPayload.placeholder_image,
          handleInputChange: handleInputChange,
        },
      ],
    },
    {
      title: 'Poster header (beef merchandising PDF)',
      fields: [
        {
          name: 'poster_partner_name',
          label: 'Partner name',
          description:
            'Shown in the top-right of the poster header above the QR code (for example, a retail partner name). Leave blank to omit.',
          type: 'text',
          value: retailerPayload.poster_partner_name,
          handleInputChange: handleInputChange,
        },
        {
          name: 'poster_partner_logo',
          label: 'Partner logo',
          description:
            'Optional logo beside the QR code in the poster header. Leave empty to omit.',
          type: 'image',
          value: retailerPayload.poster_partner_logo,
          handleInputChange: handleInputChange,
        },
      ],
    },
  ];

  const makeUpdateRetailerRequest = async () => {
    try {
      // setLoading(true);

      let payload = {
        ...retailerPayload,
      };

      // if (englishTranslation?.id) {
      //   // build translation payload
      //   const translations = { create: [], update: [], delete: [] };
      //   translations.update.push(englishTranslation)

      //   // override retailerPayload.translations
      //   payload.translations = translations;
      // }

      const updateRetailerResponse = await API.updateRetailer(payload);
      dispatch(updateRetailer(updateRetailerResponse));
      notify('success', 'Retailer updated');
    } catch (error) {
      console.log('error: ', error);
      notify('error', 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <Box 
      sx={{
        flexGrow: 1,
      }}
    >
      <Grid container>
        <Grid item xs={12} md={7}>
          {formSections.map((section) => (
            <Box key={section.title}>
              {
                section.title &&
                <Typography
                  className='form-section-title'
                  variant="h4"
                >
                  {section.title}
                </Typography>
              }

              <Grid container spacing={2}>
                {section.fields.map(field => (
                  <Fragment key={field.name}>
                    <Grid
                      key={field.name}
                      item
                      {
                        ...(['colour'].includes(field?.type) ? {
                            xs: 12,
                            md: 4,
                          } : {
                            xs: 12,
                          }
                        )
                      }
                    >
                      { chooseInputComponent(field) }
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} md={7} >
          <Button
            disabled={loading}
            className='form-button'
            sx={{ width: '40%', my: 5 }}
            size="large"
            variant="contained"
            onClick={makeUpdateRetailerRequest}
          >
            {loading ? 'Updating... ' : 'Update' }
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default BrandMediaForm